import type {
    CustomHeaderGroupProps,
    IHeaderParams,
} from "@/ui/molecules/Grid";

import Typography from "@/ui/atoms/Typography";
import { Tooltip, Icon, IconBox } from "@proda-ai/ui-kit";
import type { BoxProps } from "@/ui/atoms/Box";

export const testIds = {
    main: "GridHeaderComponent",
};
export const GridHeaderComponent = (
    props: (IHeaderParams | CustomHeaderGroupProps) &
        BoxProps & {
            textAlign: "center" | "left" | "right";
            extraInfo?: boolean;
            redirect?: () => void;
            url?: string;
            tooltipContent?: React.ReactNode;
            contentStyle?: React.CSSProperties;
            checkbox?: {
                checked: boolean;
                onChange: () => void;
            };
            isDisabled?: boolean;
        },
) => {
    const {
        sx,
        tooltipContent,
        displayName,
        textAlign = "left",
        extraInfo,
        redirect,
        url,
        contentStyle,
        checkbox,
        isDisabled,
    } = props;

    const handleHeaderClicked = (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (redirect) {
            e.preventDefault();
            redirect();
        }
    };

    const disabledStyle: React.CSSProperties | undefined =
        isDisabled === true ? { textDecoration: "line-through" } : undefined;

    const content = (
        <Typography
            data-testid={testIds.main}
            variant="h4"
            sx={{
                height: "100%",
                width: "100%",
                fontWeight: 500,
                textAlign,
                color:
                    isDisabled === true
                        ? "var(--text-color-disabled)"
                        : "var(--text-color-light)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: checkbox !== undefined ? "4px" : undefined,
                ...sx,
            }}
        >
            {checkbox !== undefined && (
                <input
                    type="checkbox"
                    checked={checkbox.checked}
                    onChange={checkbox.onChange}
                    style={{ cursor: "pointer", flexShrink: 0 }}
                />
            )}
            {url !== undefined ? (
                <a
                    href={url}
                    onClick={handleHeaderClicked}
                    style={{
                        width: "100%",
                        cursor: "pointer",
                        ...contentStyle,
                        ...disabledStyle,
                    }}
                >
                    {displayName}
                </a>
            ) : (
                <span
                    style={{
                        width: "100%",
                        ...contentStyle,
                        ...disabledStyle,
                    }}
                >
                    {displayName}
                </span>
            )}
            {extraInfo !== undefined && (
                <IconBox ml={1}>
                    <Icon icon="circle-info" size="sm" />
                </IconBox>
            )}
        </Typography>
    );

    return tooltipContent !== undefined ? (
        <Tooltip
            content={tooltipContent}
            style={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            {content}
        </Tooltip>
    ) : (
        content
    );
};

export default GridHeaderComponent;
